import { ODSButton, ODSCardBasic, ODSText } from "@telekom-ods/react-ui-kit";

import { APP_CONSTANTS } from "../../../core/config/appConstants";
import classes from "./OutOfTime.module.scss";
import Container from "../../../shared/components/Container/Container";

const OutOfTime = () => {
	const buttons = [
		{
			label: "Zu Telekom.de",
			variant: "outline",
			onClick: () =>
				(window.location.href =
					APP_CONSTANTS.LINK.TELEKOM),
			size: "small",
			tabIndex: "2",
			ariaLabel: "Link zu Telekom.de"
		}
	];
	const icons = [
		{
			name: "error-type-standard",
			size: 64,
			color: "var(--color-error)"
		}
	];

	return (
		<Container
			title="Bestätigung nicht möglich"
			description="Leider ist das Zeitfenster von 7 Tagen für die Bestätigung inzwischen abgelaufen."
			buttons={buttons}
			icon={icons[0]}
		>
			<div className={classes.cardContainer}>
				<ODSCardBasic
					actionSlot={
						<div
							className={
								classes.cardButtonContainer
							}
						>
							<ODSButton
								label="Zum Kundencenter"
								onClick={() =>
									(window.location.href =
										APP_CONSTANTS.LINK.KUNDENCENTER)
								}
								size="small"
								tabIndex={1}
							/>
						</div>
					}
					size="large"
				>
					<ODSText as="h2" className="cardHeader">
						E-Mail-Adresse im Kundencenter
						bestätigen
					</ODSText>
					<ODSText as="pa" className="body">
						Loggen Sie sich in das
						Kundencenter ein, um Ihre
						E-Mail-Adresse dort zu
						bestätigen.
					</ODSText>
				</ODSCardBasic>
			</div>
		</Container>
	);
};

export default OutOfTime;
